import { render } from "./EditFieldModal.vue?vue&type=template&id=a5546240&scoped=true"
import script from "./EditFieldModal.vue?vue&type=script&lang=js"
export * from "./EditFieldModal.vue?vue&type=script&lang=js"

import "./EditFieldModal.vue?vue&type=style&index=0&id=a5546240&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5546240"]])

export default __exports__